import EcoButton from 'eco-design/base/eco-button';
import { useProductStore } from '@elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
// import { useCountDown } from 'ahooks';
import EcoIconPlay from 'eco-design-micro/icons/eco-icon-play';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';
import { useState } from 'react';
// import { useGlobal } from '@/utils/useGlobal';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const youtubeMap: Record<string, string> = {
    eu: 'https://www.youtube.com/embed/b73Y2YR1WE0',
    de: 'https://www.youtube.com/embed/YzGcsimZIUU',
    fr: 'https://www.youtube.com/embed/VXQVBhAacVo',
    it: 'https://www.youtube.com/embed/0dfnLeJEK0s',
    es: 'https://www.youtube.com/embed/WZHx9pnagK4',
};

const FooterB = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useLang('theProduct');
    // const { getSystemTime } = useGlobal();
    const { timeLine, pageStatus } = useProductStore();
    const { locale } = getLocal();
    const youtubeHref = youtubeMap[locale] || youtubeMap.eu;

    // 写死使用阶段一的时间
    // const [, formattedRes] = useCountDown({
    //     // leftTime: now - Number(startTime),
    //     leftTime: timeLine[IPageStatus.statusC].start - getSystemTime(),
    // });
    // // const { days, hours, minutes, seconds } = formattedRes;

    // const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    const handleAnchor = () => {
        document.querySelector('#Products')?.scrollIntoView({
            behavior: 'smooth',
        });
    };

    return (
        <div className="banner-bottom">
            {pageStatus !== IPageStatus.statusC && <p className="banner-bottom-desc">{t('BannerA.desc3')}</p>}
            {/* <div className="countdown-content">
                <div className="time">
                    <span className="num">{handleCompletion(days)}</span>
                    <span className="text">{t('BannerA.day')}</span>
                </div>
                <span className="colon">:</span>
                <div className="time">
                    <span className="num">{handleCompletion(hours)}</span>
                    <span className="text">{t('BannerA.hours')}</span>
                </div>
                <span className="colon">:</span>
                <div className="time">
                    <span className="num">{handleCompletion(minutes)}</span>
                    <span className="text">{t('BannerA.minutes')}</span>
                </div>
                <span className="colon">:</span>
                <div className="time">
                    <span className="num">{handleCompletion(seconds)}</span>
                    <span className="text">{t('BannerA.seconds')}</span>
                </div>
            </div> */}
            <div className="btn-tools">
                <EcoButton
                    lType="filled"
                    lSize="extra-large"
                    lRadius="ellipse"
                    lBgColor="#3F68E0"
                    lDataLayer={{
                        event: 'uaEvent',
                        event_name: 'click_anchor',
                        position: t('productlist.productlist_title2'),
                        button_name: t('BannerA.btn2'),
                    }}
                    onClick={handleAnchor}
                    lChildren={t('BannerA.btn2')}
                />
                <EcoButton
                    lType="outlined"
                    lSize="extra-large"
                    lRadius="ellipse"
                    lTheme="blue"
                    lDataLayer={{
                        event: 'uaEvent',
                        event_name: 'video',
                        title_name: t('BannerA.title'),
                        position: 'Product Detail_1',
                    }}
                    onClick={() => {
                        setIsOpen(true);
                    }}
                >
                    {t('BannerA.btn3')}
                    <EcoIconPlay />
                </EcoButton>
            </div>
            {isOpen && <EcoDialogVideo open={isOpen} src={youtubeHref} callback={() => setIsOpen(false)} />}
        </div>
    );
};

export default FooterB;
